<template>
  <div>
    <v-dialog v-model="dialog.status" :max-width="(maxWidth ? maxWidth : 500)+'px' " :persistent="persistent">
      <v-card>
        <v-card-title class="pb-0">
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md fluid pa-0>
            <slot></slot>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: {
    dialog: Object,
    title: String,
    maxWidth: Number,
    actions: Object,
    persistent: Boolean
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragments/Dialog.vue